import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setBufferLoading, setBaseNote, setPianoLabels, setDefaultMt, setTonesMT, setSustainedNotes } from "./store/actions";

import {
  A_1,
  A0,
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  Ab0,
  Ab1,
  Ab2,
  Ab3,
  Ab4,
  Ab5,
  Ab6,
  B_1,
  B0,
  B1,
  B2,
  B3,
  B4,
  B5,
  B6,
  Bb_1,
  Bb0,
  Bb1,
  Bb2,
  Bb3,
  Bb4,
  Bb5,
  Bb6,
  CHash0,
  CHash3,
  C0,
  C1,
  C2,
  C3,
  C4,
  C5,
  C6,
  C7,
  D0,
  D1,
  D2,
  D3,
  D4,
  D5,
  D6,
  Db1,
  Db2,
  Db4,
  Db5,
  Db6,
  E0,
  E1,
  E2,
  E3,
  E4,
  E5,
  E6,
  Eb0,
  Eb1,
  Eb2,
  Eb3,
  Eb4,
  Eb5,
  Eb6,
  FHash0,
  FHash1,
  FHash2,
  FHash3,
  FHash4,
  FHash5,
  FHash6,
  F0,
  F1,
  F2,
  F3,
  F4,
  F5,
  F6,
  G0,
  G1,
  G2,
  G3,
  G4,
  G5,
  G6,
} from "./audios"; //all piano notes
import { generateStandardLabels } from "./helpers/pianoHelpers";
import { tonalC } from "./helpers/keyLabelsMapper";

const midiToAudioMap = {
  21: A_1,
  22: Bb_1,
  23: B_1,
  24: C0,
  25: CHash0,
  26: D0,
  27: Eb0,
  28: E0,
  29: F0,
  30: FHash0,
  31: G0,
  32: Ab0,
  33: A0,
  34: Bb0,
  35: B0,
  36: C1,
  37: Db1,
  38: D1,
  39: Eb1,
  40: E1,
  41: F1,
  42: FHash1,
  43: G1,
  44: Ab1,
  45: A1,
  46: Bb1,
  47: B1,
  48: C2,
  49: Db2,
  50: D2,
  51: Eb2,
  52: E2,
  53: F2,
  54: FHash2,
  55: G2,
  56: Ab2,
  57: A2,
  58: Bb2,
  59: B2,
  60: C3,
  61: CHash3,
  62: D3,
  63: Eb3,
  64: E3,
  65: F3,
  66: FHash3,
  67: G3,
  68: Ab3,
  69: A3,
  70: Bb3,
  71: B3,
  72: C4,
  73: Db4,
  74: D4,
  75: Eb4,
  76: E4,
  77: F4,
  78: FHash4,
  79: G4,
  80: Ab4,
  81: A4,
  82: Bb4,
  83: B4,
  84: C5,
  85: Db5,
  86: D5,
  87: Eb5,
  88: E5,
  89: F5,
  90: FHash5,
  91: G5,
  92: Ab5,
  93: A5,
  94: Bb5,
  95: B5,
  96: C6,
  97: Db6,
  98: D6,
  99: Eb6,
  100: E6,
  101: F6,
  102: FHash6,
  103: G6,
  104: Ab6,
  105: A6,
  106: Bb6,
  107: B6,
  108: C7,
};
const defaultMt = {
  baseNote: 3,
  tones: 2,
  modesOfScales: 0,
  modesOfScalesValues:   {
    x: 0,
    y: 0,
    prevDegree: "1.",
    name: "ionian",
    nameColor: "#FF0000",
    formulae: [1, 3, 5, 6, 8, 10, 12],
    formulaeOriginal: ["1", "3", "5", "6", "8", "0", "B"],
    numbers: ["1", "2", "3", "4", "5", "6", "7"],
    underlinedNumbers: ["4", "7"],
  },
}
class SoundfontProvider extends React.Component {
  static propTypes = {
    onLoad: PropTypes.func,
    render: PropTypes.func,
    setBufferLoading: PropTypes.func,
    bufferLoading: PropTypes.bool,
    setBaseNote: PropTypes.func,
    setPianoLabels: PropTypes.func,
    setDefaultMt: PropTypes.func,
    setTonesMT: PropTypes.func,
    sustainPedal: PropTypes.bool,
    setSustainedNotes: PropTypes.func,
    sustainedNotes: PropTypes.instanceOf(Set),
  };

  constructor(props) {
    super(props);
    this.state = {
      activeAudioNodes: {},
    };
    this.audioContext = this.props.audioContext || new AudioContext();
    this.audioBuffers = {};
    this.FADE_TIME = 0.1;
  }

  componentDidMount() {
    this.loadAllAudioBuffers();
    if (this.props.onLoad) {
      this.props.onLoad({
        playNote: this.playNote,
        stopNote: this.stopNote,
        stopAllNotes: this.stopAllNotes,
      });
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sustainPedal && !this.props.sustainPedal) {
      this.handleSustainRelease();
    }
  }

  componentWillUnmount() {
    this.stopAllNotes();
  }

  loadAllAudioBuffers = async () => {
    const bufferPromises = Object.entries(midiToAudioMap).map(
      async ([midiNumber, audioFile]) => {
        try {
          const response = await fetch(audioFile);
          const arrayBuffer = await response.arrayBuffer();
          const audioBuffer = await this.audioContext.decodeAudioData(
            arrayBuffer
          );
          this.audioBuffers[midiNumber] = audioBuffer;
        } catch (error) {
          console.error(`Error loading audio for MIDI ${midiNumber}:`, error);
        }
      }
    );

    try {
      if (this.props.bufferLoading) return;
      this.props.setBufferLoading(true);

      document.querySelectorAll(".ReactPiano__NoteLabelContainer").forEach((x) => {
        x.classList.remove("hide-labels");
      });
      let labelsC = generateStandardLabels(tonalC);
      this.props.setPianoLabels(labelsC);
      this.props.setBaseNote(tonalC);
      this.props.setDefaultMt(defaultMt);
      this.props.setTonesMT(defaultMt);
      await Promise.all(bufferPromises);

      this.props.setBufferLoading(false);
    } catch (error) {
      console.error("Error loading all audio buffers:", error);
    }
  };

  playNote = (midiNumber) => {
    const audioBuffer = this.audioBuffers[midiNumber];
    if (!audioBuffer) {
      console.error(`Audio buffer not found for MIDI ${midiNumber}`);
      return;
    }

    try {
      if (this.state.activeAudioNodes[midiNumber]) {
        this.state.activeAudioNodes[midiNumber].source.stop();
      }

      const source = this.audioContext.createBufferSource();
      source.buffer = this.audioBuffers[midiNumber];

      const gainNode = this.audioContext.createGain();
      gainNode.gain.setValueAtTime(1, this.audioContext.currentTime);

      source.connect(gainNode);
      gainNode.connect(this.audioContext.destination);
      source.start();

      const startTime = this.audioContext.currentTime;

      source.onended = () => {
        
        // Only remove the node if it's the same one that triggered the onended event
        this.setState((prevState) => {
          const currentNode = prevState.activeAudioNodes[midiNumber];
          if (currentNode && currentNode.startTime === startTime) {
            const updatedNodes = { ...prevState.activeAudioNodes };
            delete updatedNodes[midiNumber];
            return { activeAudioNodes: updatedNodes };
          }
          return prevState;
        });
      };

      this.setState((prevState) => ({
        activeAudioNodes: {
          ...prevState.activeAudioNodes,
          [midiNumber]: { source, gainNode, startTime, isHeld: true },
        }
      }), () => {
        // Only add to sustainedNotes if the sustain pedal is pressed
        if (this.props.sustainPedal) {
          const newSustainedNotes = new Set(this.props.sustainedNotes);
          newSustainedNotes.add(midiNumber);
          this.props.setSustainedNotes(newSustainedNotes);
        }
      });
    } catch (error) {
      console.error(`Error playing note for MIDI number ${midiNumber}:`, error);
    }
  };

  stopNote = (midiNumber) => {
    const node = this.state.activeAudioNodes[midiNumber];
    if (node) {
      node.isHeld = false;
    }

    // If sustain is on, don't stop the note
    if (this.props.sustainPedal) {
      return;
    }

    // Stop the note if it exists and sustain is off
    if (node && node.gainNode) {
      const fade = this.FADE_TIME;
      node.gainNode.gain.cancelScheduledValues(this.audioContext.currentTime);
      node.gainNode.gain.setValueAtTime(
        node.gainNode.gain.value,
        this.audioContext.currentTime
      );
      node.gainNode.gain.linearRampToValueAtTime(
        0,
        this.audioContext.currentTime + fade
      );
      node.source.stop(this.audioContext.currentTime + fade);

      this.setState((prevState) => {
        const updatedNodes = { ...prevState.activeAudioNodes };
        delete updatedNodes[midiNumber];
        return { activeAudioNodes: updatedNodes };
      }, () => {
        // Remove from sustainedNotes
        const newSustainedNotes = new Set(this.props.sustainedNotes);
        newSustainedNotes.delete(midiNumber);
        this.props.setSustainedNotes(newSustainedNotes);
      });
    }
  };

  handleSustainRelease = () => {
    // When sustain pedal is released, stop all notes that aren't being held
    Object.entries(this.state.activeAudioNodes).forEach(([midiNumber, node]) => {
      if (!node.isHeld) {
        this.stopNote(parseInt(midiNumber));
      }
    });
    // Clear sustainedNotes in Redux
    this.props.setSustainedNotes(new Set());
  };

  stopAllNotes = () => {
    Object.values(this.state.activeAudioNodes).forEach((node) => {
      if (node && node.gainNode) {
        const fade = this.FADE_TIME;
        node.gainNode.gain.cancelScheduledValues(this.audioContext.currentTime);
        node.gainNode.gain.setValueAtTime(
          node.gainNode.gain.value,
          this.audioContext.currentTime
        );
        node.gainNode.gain.linearRampToValueAtTime(
          0,
          this.audioContext.currentTime + fade
        );
        node.source.stop(this.audioContext.currentTime + fade);
      }
    });
    this.setState({ 
      activeAudioNodes: {}
    });
    // Also clear sustainedNotes in Redux
    this.props.setSustainedNotes(new Set());
  };

  render() {
    return this.props.render
      ? this.props.render({
          playNote: this.playNote,
          stopNote: this.stopNote,
          stopAllNotes: this.stopAllNotes,
        })
      : null;
  }
}

const mapStateToProps = (state) => ({
  audioContext: state.audioContext,
  bufferLoading: state.bufferLoading,
  sustainPedal: state.sustainPedal,
  sustainedNotes: state.sustainedNotes,
});

const mapDispatchToProps = {
  setBufferLoading,
  setBaseNote,
  setPianoLabels,
  setTonesMT,
  setDefaultMt,
  setSustainedNotes,
};

export default connect(mapStateToProps, mapDispatchToProps)(SoundfontProvider);